export default __webpack_public_path__ + "static/media/check-green.4ef53477.svg";